import React from 'react'
import {Routes, Route, Navigate} from 'react-router-dom';

import { PrivateRoute, CenterCircularProgress } from 'common';
import { LoginPage } from 'auth/LoginPage';
import { ForgotPassword } from 'auth/ForgotPassword';
import { ResetPage } from 'auth/ResetPage';
import { Claims } from 'claim';
import { Invoices } from 'invoice';
import { CustomerClaimDetail, VendorClaimDetail } from 'claim';
import { NewReferral } from 'referral/NewReferral';
import { ClientHome } from 'home';
import { VendorInvoiceDetail } from 'invoice/VendorInvoiceDetail';
import { ProfilePage } from 'user/ProfilePage';
import ACHPanel from 'vendor/ACHPanel';
import permissions from 'auth/permissions';
import {ChangeNote} from "./changeNote/ChangeNote";
import {SignUpPage} from "./auth/SignUpPage";

const RootRedirect = ({ authorized, pending}) => {
    if (authorized) {
        return <Navigate to='/home' replace />;
    } else if (!pending) {
        return <Navigate to="/auth/login" replace />;
    } else {
        return <CenterCircularProgress fullScreen/>;
    }
};

const customerRoutes = (authorized, pending) => (
    <Routes>
        <Route path="/" element={<RootRedirect authorized={authorized} pending={pending} /> } />
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/forgot" element={<ForgotPassword/>} />
        <Route path="/auth/reset/:token" element={<ResetPage/>} />
        <Route path="/profile" element={
            <PrivateRoute>
                <ProfilePage/>
            </PrivateRoute>
        } />
        <Route path="/changeNote" element={
            <PrivateRoute> <ChangeNote/>  </PrivateRoute>
        } />
        <Route path="/home" element={
            <PrivateRoute> <ClientHome/>  </PrivateRoute>
        } />
        <Route exact path="/claim" element={
            <PrivateRoute> <Claims/> </PrivateRoute>
        } />
        <Route path="/claim/:claimId" element={
            <PrivateRoute> <CustomerClaimDetail/> </PrivateRoute>
        }  />
        <Route path="/referral/create" element={
            <PrivateRoute> <NewReferral/> </PrivateRoute>
        } />
    </Routes>);

const vendorRoutes = (authorized, pending) => (
    <Routes>
        <Route path="/" element={<RootRedirect authorized={authorized} pending={pending} /> } />
        <Route path="/auth/login" element={<LoginPage/>} />
        <Route path="/auth/forgot" element={<ForgotPassword/>} />
        <Route path="/auth/reset/:token" element={<ResetPage/>} />
        <Route path="/profile" element={
            <PrivateRoute> <ProfilePage/> </PrivateRoute>
        } />
        <Route path="/changeNote" element={
            <PrivateRoute> <ChangeNote/> </PrivateRoute>
        } />
        <Route path="/home" element={
            <PrivateRoute> <Invoices/> </PrivateRoute>
        } />
        <Route exact path="/claim" element={
            <PrivateRoute> <Claims/> </PrivateRoute>
        } />
        <Route exact path="/invoice" element={
            <PrivateRoute> <Invoices/> </PrivateRoute>
        } />
        <Route path="/invoice/:invoiceId" element={
            <PrivateRoute> <VendorInvoiceDetail/> </PrivateRoute>
        } />
        <Route path="/claim/:claimId" element={
            <PrivateRoute> <VendorClaimDetail/> </PrivateRoute>
        }  />
        <Route path="/referral/create" element={
            <PrivateRoute> <NewReferral/> </PrivateRoute>
        }  />
        <Route path="/ach" element={
            <PrivateRoute requiredPermission={permissions.ManageVendorACH}> <ACHPanel/> </PrivateRoute>
        } />
        <Route path="*" element={<Navigate to="/home" replace />} />   /* This must be last */
    </Routes>);

const unauthorizedRoutes = (authorized, pending) => (
    <Routes>
        <Route path="/" element={<RootRedirect authorized={authorized} pending={pending} /> } />
        <Route path="/auth/login" element={<LoginPage/>} />
        <Route path="/auth/forgot" element={<ForgotPassword/>} />
        <Route path="/auth/reset/:token" element={<ResetPage/>} />
        <Route path="/auth/signup" element={<SignUpPage/>} />
        <Route path="/web/referral" element={<NewReferral/>} />
    </Routes>);

export const getDynamicRoutes = (userType, authorized, pending) => {
    if (userType === 'Customer') {
        return customerRoutes(authorized, pending);
    }
    else if (userType === 'Vendor') {
        return vendorRoutes(authorized, pending);
    }
    else {
        return unauthorizedRoutes(authorized, pending);
    }
}